import React, { memo, useCallback } from 'react'

import * as styles from './tabButton.module.scss'
import classNames from 'classnames'
import { TabButtonProps } from '../types'

const TabButton = ({
   id,
   label,
   onTabClick,
   isActive,
   showCircle,
   isDisabled,
}: TabButtonProps) => {
   const handleClick = useCallback(() => onTabClick(id), [id, onTabClick])

   const className = classNames(styles.button, {
      [styles.active]: isActive,
      [styles.disabled]: isDisabled,
   })

   return (
      <button
         type="button"
         onClick={handleClick}
         className={className}
         disabled={isDisabled}
      >
         <span>{label}</span>
         {showCircle && <span className={styles.circle}></span>}
      </button>
   )
}

export default memo(TabButton)
